/**
 * PUX UI-3 — what a person types, as the server reads it.
 *
 * An Arabic keyboard types ٠–٩ (Arabic-Indic) or ۰–۹ (Extended, Persian
 * keyboards), and the server's rules (`^\d{10}$`, `^3\d{13}3$`, decimal
 * amounts) accept Latin digits only. Fidelen shows Latin digits everywhere, so
 * a value is normalised as it is typed — never refused for the keyboard it came
 * from (FORM-09).
 */

/** Arabic-Indic (U+0660…) and Extended Arabic-Indic (U+06F0…) digits, as Latin digits. */
export function toLatinDigits(value: string): string {
  return value.replace(/[٠-٩۰-۹]/g, (digit) => {
    const code = digit.charCodeAt(0);

    return String(code - (code >= 0x06f0 ? 0x06f0 : 0x0660));
  });
}

/**
 * An amount as typed, in the form `decimal.ts` reads: Latin digits, the Arabic
 * decimal separator (٫ U+066B) as a point, the Arabic thousands separator
 * (٬ U+066C) and spaces dropped. A Latin comma is KEPT, so "1,5" is refused
 * rather than silently read as fifteen: what it meant is not ours to guess.
 */
export function normaliseDecimalInput(value: string): string {
  return toLatinDigits(value)
    .replace(/٫/g, '.')
    .replace(/[\u066c\s\u00a0\u202f]/g, '');
}
